import "../closeto.js";
import "../message.js";
import "../player-update.js";
import "../time.js";
import "../uid.js";
import "../vector2.js";

import "../configuration.js";

import "./block.js";
import "./browser.js";
import "./camera.js";
import "./cancelbubble.js";
import "./card.js";
import "./chat.js";
import "./client.js";
import "./connection-list.js";
import "./dialogue.js";
import "./game.js";
import "./icon.js";
import "./menu.js";
import "./not-found.js";
import "./pagination.js";
import "./pen.js";
import "./player-animator.js";
import "./player-configuration.js";
import "./player-controller.js";
import "./player.js";
import "./preventdefault.js";
import "./profile-editor.js";
import "./profile.js";
import "./router.js";
import "./server.js";
import "./store.js";
import "./tutorial.js";
import "./world-document.js";
import "./world-list-item.js";
import "./world-list.js";
import "./world-thumbnail.js";
import "./world.js";

import "./list-dialogue.js";

import "./save-form.js";
import "./status.js";
import "./topbar.js";
import "./block-selector.js";

addEventListener("load", () => {
  new Store();
  new Router({
    "^/$": Browser,
    "^/(local|ws|wss)/(.*)": Game,
  });
});
